import { FC, useState } from 'react';
import Field from 'components/shared/form/presentational/Field';
import Form from 'components/shared/form/presentational/Form';
import useTranslate from 'lib/languages/useTranslate';
import PostCodeAutoComplete from 'components/shared/form/presentational/PostCodeAutoComplete';
import { useSelector } from 'react-redux';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import { getTheme } from 'selectors/darkMode';
import clsx from 'clsx';
import { PersonalDetailSection } from 'lib/type';
interface EditAddressDetailsProps {
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    buildingNo?: string;
    buildingName?: string;
    streetAddress?: string;
    town?: string;
    postcode?: string;
    country?: string;
    handleChange: (field: string, value: string) => void;
    handleSubmit: (section: PersonalDetailSection) => Promise<any>;
    isPosting: boolean;
    error: any;
    resetData: () => void;
}

const EditAddressDetails: FC<EditAddressDetailsProps> = ({
    handleChange,
    handleSubmit,
    isPosting,
    error,
    resetData,
    ...props
}) => {
    const translate = useTranslate('personalDetails.form');
    const isDarkModeEnabled = useSelector(getTheme);
    const {
        addressLine1 = '',
        addressLine2 = '',
        addressLine3 = '',
        buildingNo = '',
        buildingName = '',
        streetAddress = '',
        town = '',
        postcode = '',
    } = props;

    const [hasSelectedAddress, setHasSelectedAddress] = useState(false);
    const isSubmitDisabled = !hasSelectedAddress;

    const handleFormSubmit = async () => {
        await handleSubmit(PersonalDetailSection.ADDRESS);
    };

    const handleAddressChange = (field: string, value: string) => {
        setHasSelectedAddress(true);
        handleChange(field, value);
    };

    return (
        <Form
            disabledButton={isSubmitDisabled}
            submitText={translate('save')}
            onSubmit={handleFormSubmit}
            isPosting={isPosting}
            error={error ? translate('errorMessage') : ''}
            tracking
        >
            <Field required>
                <PostCodeAutoComplete
                    value={postcode}
                    onChange={handleAddressChange}
                    classes="generic-input bg mb"
                    resetData={resetData}
                />
            </Field>
            <div
                className={clsx('address-details', {
                    'dark-mode': isDarkModeEnabled,
                })}
            >
                {addressLine1 ? (
                    <>
                        <Typography>{addressLine1}</Typography>
                        <Typography>{addressLine2}</Typography>
                        <Typography>{addressLine3}</Typography>
                    </>
                ) : (
                    <>
                        <Typography>{buildingNo}</Typography>
                        <Typography>{buildingName}</Typography>
                        <Typography>{streetAddress}</Typography>
                    </>
                )}
                <Typography>{town}</Typography>
                <Typography>{postcode}</Typography>
            </div>
        </Form>
    );
};

export default EditAddressDetails;
